import {FC} from 'react';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Box from '@mui/material/Box';
import TableHeadContactPerson from '../../../AddCompany/AddCompanyForm/ContactPersonForm/TableHeadContactPerson/TableHeadContactPerson';
import CompanyContactPersons from './ContactPersonsOfCompanyBeingEdited';

import {IContactPerson} from '../../../../../../shared/types/person.types';
import {IHeadCellContactPerson} from '../../../../../../shared/types/table.types';

interface IContactPersonsComponent {
  contactPersons: IContactPerson[];
}

const headCells: IHeadCellContactPerson[] = [
  {
    disablePadding: false,
    id: 'fullPersonName',
    label: 'ФИО',
  },
  {
    disablePadding: false,
    id: 'phoneNumber',
    label: 'Номер телефона',
  },
  {
    disablePadding: false,
    id: 'email',
    label: 'Email',
  },
  {
    disablePadding: false,
    id: 'birthDate',
    label: 'Дата рождения',
  },
];

const ContactPersons: FC<IContactPersonsComponent> = ({contactPersons}) => {
  return (
    <Box sx={{width: '100%'}}>
      <TableContainer>
        <Table size="small">
          <TableHeadContactPerson headCells={headCells} collapse actionButtons />
          <CompanyContactPersons contactPersons={contactPersons} />
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ContactPersons;
